<template>
  <div
    v-if="showButtons"
    class="flex gap-2"
  >
    <button
      v-for="(button, i) in buttons"
      :key="i"
      class="filtersTimetableBtns__btn col"
      :class="{
        'filtersTimetableBtns__btn--active': button.isActive
      }"
      tabindex="-1"
      :disabled="!button.isEnabled"
      @click="buttonClick(button)"
    >
      <span>{{ button.text }}</span>
    </button>
  </div>
</template>

<script setup>
import { l } from '@utils/toolbox';

const props = defineProps({
	currentIndexes: {
		type: Array,
		required: true
	},
	uniqueTimes: {
		type: Array,
		required: true
	}
});

const emit = defineEmits(['update:filterObject']);

const showButtons = computed(() => buttons.value.filter(button => button.isEnabled).length >= 2);

const buttons = computed(() => {
	return [
		{
			text: l('showresult.filter.travelTime.morning'),
			values: times.value.morning,
			isEnabled: times.value.morning.length >= 2,
			isActive: props.currentIndexes?.[0] === times.value.morning?.[0] && props.currentIndexes?.[1] === times.value.morning?.[times.value.morning?.length - 1]
		},
		{
			text: l('showresult.filter.travelTime.afternoon'),
			values: times.value.afternoon,
			isEnabled: times.value.afternoon.length >= 2,
			isActive: props.currentIndexes?.[0] === times.value.afternoon?.[0] && props.currentIndexes?.[1] === times.value.afternoon?.[times.value.afternoon?.length - 1]
		},
		{
			text: l('showresult.filter.travelTime.evening'),
			isEnabled: times.value.evening.length >= 2,
			values: times.value.evening,
			isActive: props.currentIndexes?.[0] === times.value.evening?.[0] && props.currentIndexes?.[1] === times.value.evening?.[times.value.evening?.length - 1]
		}
	];
});


const times = computed(() => {
	const items = {
		morning: [],
		afternoon: [],
		evening: []
	};

	const startDate = new Date(props?.uniqueTimes?.[0] * 1000);
	props.uniqueTimes.forEach((time, index) => {
		// if not same day, skip
		if (new Date(time * 1000).getDate() !== startDate.getDate()) {
			return;
		}
		const currentHour = new Date(time * 1000).getHours();
		if (currentHour < 12) {
			items.morning.push(index);
		} else if (currentHour >= 12 && currentHour <= 16) {
			items.afternoon.push(index);
		} else if (currentHour >= 17) {
			items.evening.push(index);
		}
	});

	return items;
});

function buttonClick (button) {
	if (button.isActive) {
		emit('update:filterObject', [0, props.uniqueTimes.length - 1]);
	} else {
		emit('update:filterObject', firstAndLastArrayValues(button.values));
	}
}

function firstAndLastArrayValues (array) {
	if (array.length >= 2) {
		return [array[0], array[array.length - 1]];
	}
	return [];
}
</script>
<style lang="scss">
.filtersTimetableBtns {
	margin: 2rem 0;
}

.filtersTimetableBtns__btn {
	outline: none;
	padding: .3rem .6rem;
	width: 100%;
	border: 0.1rem solid $neutral-border-color;
	font-size: 1.2rem;
	overflow: hidden;
	height: 3.4rem;
	border-radius: $borderRadius-xs;
	background-color: $white;

	& > * {
		pointer-events: none;
	}

	&:disabled {
		background-color: $color-grey-100;
		color: $color-grey-700;
	}
}

.filtersTimetableBtns__btn--active {
	background-color: $cta-btn-bg;
	border: 0.1rem solid $cta-btn-bg;
}
</style>
